import { BaseState } from '@/store/base-state';
import { AlfaApiLoanApplicationStatuses } from '../types';

export default class AlfaApiLoanApplicationStatusesState extends BaseState {
  statuses: AlfaApiLoanApplicationStatuses.AlfaApiLoanApplicationStatus[] = [];
  statuses_loading = false;
}
